import { put, takeEvery } from "redux-saga/effects";

import { NavigationActions, navigationActions } from "@gamedev-web/gamedev-sdk-core";

import { PageType, siteLocationPrefix } from "../../constants";
import {
  GameConceptIdSearchParam,
  PitchConceptIdSearchParam,
} from "../../helpers/dataFetchingHelpers";
import { Programs } from "../../models/programsConfig";
import { crmActions } from "../actions/crmApiActions";
import { statusActions } from "../actions/statusActions";

export function* navigationSagaHandler(
  action: ReturnType<typeof navigationActions.navigateToPath>
) {
  // Clearing errors on navigation
  yield put(statusActions.updateError(undefined));

  // Set current OnboardingHub program
  const pathname = action.newLocation.pathname;
  let currentProgram = Programs.Unset;
  let currentPageType: PageType | undefined;
  if (pathname.startsWith(`${siteLocationPrefix}/id`)) {
    currentProgram = Programs.IdXbox;
    currentPageType = PageType.IdXboxApplication;
  } else if (pathname.startsWith(`${siteLocationPrefix}/pitch`)) {
    currentProgram = Programs.Pitch;
    currentPageType = PageType.PitchApplication;
  } else if (pathname.startsWith(`${siteLocationPrefix}/xbox`)) {
    currentProgram = Programs.Aaa;
    currentPageType = PageType.AaaApplication;
  } else if (pathname.startsWith(`${siteLocationPrefix}/program-selection`)) {
    currentPageType = PageType.ProgramSelection;
  }
  yield put(statusActions.updateCurrentProgram(currentProgram));
  yield put(statusActions.updateCurrentPageType(currentPageType));

  if (action.newLocation.search) {
    const searchParams = new URLSearchParams(action.newLocation.search);
    switch (currentProgram) {
      case Programs.Aaa:
      case Programs.IdXbox:
        yield put(
          crmActions.fetchCrmData.start(
            currentPageType,
            currentProgram,
            searchParams.get(GameConceptIdSearchParam) as string
          )
        );
        break;
      case Programs.Pitch:
        yield put(
          crmActions.fetchCrmData.start(
            currentPageType,
            currentProgram,
            searchParams.get(PitchConceptIdSearchParam) as string
          )
        );
        break;
    }
  }
}

export function* navigationSagas() {
  yield takeEvery(NavigationActions.LOCATION_CHANGE, navigationSagaHandler);
}
